<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <div class="page-landing:text-white page-landing:bg-petrol">
      <Hero
        v-if="hero"
        :media="hero"
        :title="title"
        :lead="lead"
        :is-landing="isLanding"
      />
      <Container v-else class="mx-auto grid-container">
        <div
          class="col-span-4 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3 page-landing:md:col-span-8 page-landing:lg:col-span-8"
        >
          <h1
            v-blokkli-editable:title
            class="pb-3 text-4xl lg:pb-6 lg:text-7xl pt-20 page-landing:lg:pt-75 page-landing:lg:text-6xl"
          >
            {{ entity?.title || title }}
          </h1>

          <div v-if="entity?.lead || lead">
            <div class="pb-10">
              <div
                v-blokkli-editable:field_lead
                class="text-xl page-landing:text-base md:text-3xl leading-6 md:leading-10 md:font-bold"
                v-html="entity?.lead || lead"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
    <div
      v-if="children && children.length"
      id="main"
      class="bg-gray-50 pt-24 pb-16"
    >
      <Container>
        <MenuList>
          <MenuListItem
            v-for="(child, key) in children"
            :key="key"
            v-bind="child"
          />
        </MenuList>
      </Container>
    </div>
    <div :id="!children || children?.length === 0 ? 'main' : ''">
      <BlokkliField :list="paragraphs" name="field_paragraphs">
        <TableOfContents />
      </BlokkliField>
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodePageFragment } from '#graphql-operations'

const props = defineProps<{
  uuid: string
  title?: string
  lead?: string
  paragraphs?: NodePageFragment['paragraphs']
  body?: string
  blokkliProps: NodePageFragment['blokkliProps']
  hero?: NodePageFragment['hero']
  children?: NodePageFragment['children']
  parent?: NodePageFragment['parent']
}>()
const route = useRoute()

// check if the page is a landing page
const isLanding = computed(() => {
  const pathSegments = route.path
    .split('/')
    .filter((segment) => segment.length > 0)

  return pathSegments.length === 2
})

const bodyClass = computed(() => (isLanding.value ? 'page-landing' : ''))

useHead({
  bodyAttrs: {
    class: bodyClass,
  },
})
</script>
